import { useState } from "react";
import PropTypes from "prop-types";

import Modal from "../modal/Modal";

import { uploadElements } from "../../api/cbs/CbsAPI";

import DragDropUploadFile from "../common/generic-upload-button/DragDropUploadFile";

import isEmpty from "../../validation/is-empty";
import { translate, tranStr } from "../../utils/translation";

CbsElementsUploadModal.propTypes = {
  cbs: PropTypes.object,
};

export function CbsElementsUploadModal(props) {
  const { cbs } = props;

  const [modal, setModal] = useState(false);

  if (isEmpty(cbs?.data)) {
    return null;
  }

  if (cbs?.data?.isPublished) {
    return null;
  }

  return (
    <div>
      <button
        id={"cbs-elements-upload-modal-open-button"}
        className="general-upload-button"
        onClick={() => {
          setModal(true);
        }}
      >
        Upload Elements
      </button>
      <Modal
        // Modal Props
        title={"Upload Elements"}
        Component={UploadElementsModal}
        modal={modal}
        setModal={setModal}
        // Component Props
        cbs={cbs}
      />
    </div>
  );
}

UploadElementsModal.propTypes = {
  cbs: PropTypes.object,
  setModal: PropTypes.func,
};

function UploadElementsModal(props) {
  const { cbs } = props;
  const { setModal } = props;

  const [error, setError] = useState({});
  const [highlight, setHighlight] = useState(false);

  const [file, setFile] = useState([]);

  // To reset File Input
  const [inputKey, setInputKey] = useState(0);

  return (
    <div className="pdu-container">
      <div className="general-row-container">
        <div className="cost-planning-upload-control-row">
          <div className="cost-planning-upload-control-label">
            {translate("Elements Template")}:
          </div>
          <a
            className="cost-planning-upload-document-button"
            href={
              "https://stcostclarityprd001.blob.core.windows.net/1-guides/CBS Elemental Breakdown Template.xlsx"
            }
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            {translate("Download")}
          </a>
        </div>
      </div>
      <div className="general-row-container">
        <FileTray file={file} />
      </div>
      <div className="general-row-container">
        <DragDropUploadFile
          setFile={setFile}
          allowMultiple={false}
          highlight={highlight}
          setHighlight={setHighlight}
          error={error}
          setError={setError}
          inputKey={inputKey}
          setInputKey={setInputKey}
        />
      </div>
      <div className="general-row-container">
        <div className="pdu-error-container">
          <div className={error.type}>
            <b>{error.text}</b>
          </div>
        </div>
      </div>
      <div className="general-button-container">
        <button
          id={"cbs-elements-upload-modal-submit-button"}
          className="general-upload-button"
          onClick={async () => {
            uploadElements(cbs, file, setError, setModal);
          }}
        >
          {translate("Upload")}
        </button>
      </div>
    </div>
  );
}

FileTray.propTypes = {
  file: PropTypes.array,
};
function FileTray(props) {
  const { file } = props;
  let fileName = tranStr("No File Added");

  if (!isEmpty(file)) {
    fileName = file[0].name;
  }

  return (
    <div className="pdu-file-display">
      <b>{translate("File")}:</b> {fileName}
    </div>
  );
}
